var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedditIconDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 42c11.046 0 20-8.954 20-20S33.046 2 22 2 2 10.954 2 22s8.954 20 20 20z",
    className: "hover",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.34 22a2.932 2.932 0 01-.426 1.564 2.892 2.892 0 01-1.194 1.096 5.302 5.302 0 01.013.66 5.407 5.407 0 01-.013.22c0 4.48-5.22 8.12-11.66 8.12S10.4 30.02 10.4 25.54a5.38 5.38 0 010-.88 2.928 2.928 0 01-1.592-1.864 2.92 2.92 0 014.812-2.916 14.309 14.309 0 015.736-2.279c.683-.11 1.373-.171 2.064-.181l1.48-6.94a.616.616 0 01.27-.395.621.621 0 01.47-.085l4.9.98a2 2 0 11-.26 1.22L24 11.3l-1.3 6.24A14.193 14.193 0 0130.4 20a2.92 2.92 0 014.94 2zm-19.848 2.765A2.005 2.005 0 0017.34 26a2.002 2.002 0 001.414-3.414 1.999 1.999 0 00-3.262 2.179zm11.455 4.801a.537.537 0 00.01-.763.54.54 0 00-.38-.163.653.653 0 00-.397.14A6.568 6.568 0 0122 30a6.58 6.58 0 01-3.215-.684 6.551 6.551 0 01-.945-.576.537.537 0 00-.724.035.543.543 0 00-.036.725 7.689 7.689 0 004.94 1.54 7.705 7.705 0 004.94-1.54l-.013.066zm-.367-3.406a2.01 2.01 0 001.457-.607 1.989 1.989 0 00.563-1.473 2 2 0 10-2 2l-.02.08z",
    fill: "#fff",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 22c0-11.59-9.41-21-21-21S1 10.41 1 22s9.41 21 21 21 21-9.41 21-21z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })));
}
export default SvgRedditIconDark;